import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";

export default function Auth() {
  const { login, register, user } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "", city: "" });
  const [loading, setLoading] = useState(false);

  React.useEffect(() => { if (user) navigate("/"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") {
        await login(form.email, form.password);
        toast.success("Welcome back, Hunter!");
      } else {
        await register(form);
        toast.success("Account created! +100 Jixxeo Coins");
      }
      navigate("/");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="jx-bg jx-grid min-h-screen flex items-center justify-center p-5 relative">
      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-6">
          <img src="/logo.png" alt="Jixxeo" className="w-24 h-24 mx-auto rounded-3xl object-cover neon-green" />
          <h1 className="font-display text-3xl mt-4 text-jixxeo-green text-glow-green">JIXXEO</h1>
          <p className="text-muted-foreground text-sm mt-1">Trash Hunter</p>
          <p className="text-white/80 text-sm mt-3 font-head font-bold">Clean the world. Earn rewards. Level up.</p>
        </div>

        <div className="glass rounded-3xl p-6 border border-white/10">
          <div className="flex bg-white/5 rounded-full p-1 mb-6">
            {["login", "register"].map((m) => (
              <button key={m} onClick={() => setMode(m)} data-testid={`tab-${m}`}
                className={`flex-1 py-2 rounded-full text-sm font-bold capitalize transition-colors ${mode === m ? "bg-jixxeo-green text-black" : "text-muted-foreground"}`}>
                {m === "login" ? "Log In" : "Sign Up"}
              </button>
            ))}
          </div>

          <form onSubmit={submit} className="space-y-3">
            {mode === "register" && (
              <Input data-testid="input-name" placeholder="Display name" value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })} required className="bg-white/5 border-white/10 rounded-xl h-12" />
            )}
            <Input data-testid="input-email" type="email" placeholder="Email" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} required className="bg-white/5 border-white/10 rounded-xl h-12" />
            <Input data-testid="input-password" type="password" placeholder="Password" value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })} required className="bg-white/5 border-white/10 rounded-xl h-12" />
            {mode === "register" && (
              <Input data-testid="input-city" placeholder="City (for local ranks)" value={form.city}
                onChange={(e) => setForm({ ...form, city: e.target.value })} className="bg-white/5 border-white/10 rounded-xl h-12" />
            )}
            <Button type="submit" disabled={loading} data-testid="submit-auth"
              className="w-full h-12 rounded-full bg-jixxeo-green text-black font-bold text-base hover:bg-jixxeo-greenDark neon-green">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Sparkles className="w-4 h-4 mr-2" />{mode === "login" ? "Enter the Hunt" : "Start Hunting"}</>}
            </Button>
          </form>
        </div>
        <p className="text-center text-xs text-muted-foreground mt-4">A gamified PWA — install it to your home screen.</p>
      </div>
    </div>
  );
}
